export default __webpack_public_path__ + "static/media/donateVector.f37ed22c.png";